import React, { Component } from 'react';
import { Configurations } from '../../Utils/Configurations';
import Geral from '../../Utils/Geral';
import axios from 'axios';
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import moment from 'moment';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import './New-Order.scss';
import TableClients from '../../Components/Table-Clients/Table-Clients';
import TableOrder from '../../Components/Table-Order/Table-Order';
import update from 'immutability-helper';
import ModalBeneficiarios from '../../Components/Modal-Beneficiarios/Modal-Beneficiarios';
import OpcaoEntrega from '../../Components/Opcao-Entrega/Opcao-Entrega';
import HeaderPedido from '../../Components/Header-Pedido/Header-Pedido';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import IntlCurrencyInput from "react-intl-currency-input";
import InputMask from 'react-input-mask';
import qs from 'qs';



const currencyConfig = {
    locale: "pt-BR",
    formats: {
        number: {
            BRL: {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
};


class NewOrder extends Component {

    constructor(props) {
        super(props);

        this.handleInputChange = this.handleInputChange.bind(this);
        this.buscaSolicitante = this.buscaSolicitante.bind(this);
        this.buscaAssinante = this.buscaAssinante.bind(this);

        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleSelectProductChange = this.handleSelectProductChange.bind(this);
        this.handleSelectPeriodChange = this.handleSelectPeriodChange.bind(this);

        this.selecionaAssinante = this.selecionaAssinante.bind(this);
        this.habilitaAdicionarProduto = this.habilitaAdicionarProduto.bind(this);
        this.adicionarProduto = this.adicionarProduto.bind(this);
        this.productBadgeType = this.productBadgeType.bind(this);
        this.handleRadio = this.handleRadio.bind(this);

        this.calculaValorItem = this.calculaValorItem.bind(this);
        this.calculaValorTotalPedido = this.calculaValorTotalPedido.bind(this);

        this.excluirItem = this.excluirItem.bind(this);
        this.finalizarPedido = this.finalizarPedido.bind(this);
        this.preparaNovoPedido = this.preparaNovoPedido.bind(this);

        this.toggleBoleto = this.toggleBoleto.bind(this);
        this.enviarEmail = this.enviarEmail.bind(this);
        this.toggleEmail = this.toggleEmail.bind(this);

        this.onDateChange = this.onDateChange.bind(this);
        this.onFocusChange = this.onFocusChange.bind(this);

        this.scrollPedido = this.scrollPedido.bind(this);

        this.enviarBoletoAnexo = this.enviarBoletoAnexo.bind(this);

        this.mudaTemBoleto = this.mudaTemBoleto.bind(this);

        this.calcularFrete = this.calcularFrete.bind(this);
        this.toggleFrete = this.toggleFrete.bind(this);
        this.habilitaFinalizarPedido = this.habilitaFinalizarPedido.bind(this);
        this.toggleErroItem = this.toggleErroItem.bind(this);

        this.desabilitaOpcaoVigencia = this.desabilitaOpcaoVigencia.bind(this);
        this.desabilitaOpcaoEntrega = this.desabilitaOpcaoEntrega.bind(this);
        this.verificaDigital = this.verificaDigital.bind(this);

        this.carregaEnderecos = this.carregaEnderecos.bind(this);
        this.salvarEndereco = this.salvarEndereco.bind(this);
        this.carregaEdicoes = this.carregaEdicoes.bind(this);

        this.filterPlano = this.filterPlano.bind(this);
        this.validacaoBuscaSolicitante = this.validacaoBuscaSolicitante.bind(this);

        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);

        this.utilizarSaldo = this.utilizarSaldo.bind(this);
        this.inserirDescontoPedido = this.inserirDescontoPedido.bind(this);

        this.verificaProdutoDigitalSelecionado = this.verificaProdutoDigitalSelecionado.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.validacaoEmail = this.validacaoEmail.bind(this);
        this.salvarBeneficiario = this.salvarBeneficiario.bind(this);
        this.validacaoTelefone = this.validacaoTelefone.bind(this);
        this.toggleMudarPlano = this.toggleMudarPlano.bind(this);
        this.botaoConfirmar = this.botaoConfirmar.bind(this);
        this.excluirBeneficiario = this.excluirBeneficiario.bind(this);
        this.toggleModalBeneficiarios = this.toggleModalBeneficiarios.bind(this);
        this.toggleModalEscolherFrete = this.toggleModalEscolherFrete.bind(this);
        this.handleRadioFrete = this.handleRadioFrete.bind(this);
        this.incluirFrete = this.incluirFrete.bind(this);
        this.calcularPrazo = this.calcularPrazo.bind(this);
        this.verificaSeTemPedido = this.verificaSeTemPedido.bind(this);
        this.trazerValorProduto = this.trazerValorProduto.bind(this);
        this.toggleErroRenovacao = this.toggleErroRenovacao.bind(this);
        this.aumentaQtde = this.aumentaQtde.bind(this);
        this.diminueQtde = this.diminueQtde.bind(this);
        this.semCodMembro = this.semCodMembro.bind(this);
        this.buscaBeneficiario = this.buscaBeneficiario.bind(this);
        this.selecionaBeneficiario = this.selecionaBeneficiario.bind(this);
        this.chamarApiBeneficiario = this.chamarApiBeneficiario.bind(this);

        this.mockValor = {
            valor: 0
        }

        this.state = {
            edicoesDisponiveis: [],
            hasError: false,
            errorMessage: '',
            flagUtilizarSaldo: false,
            saldoOriginal: this.mockValor.valor,
            saldoAtual: this.mockValor.valor,
            opcaoDesconto: "percentual",
            saldoAtualizado: null,
            valorMaxDesconto: null,
            nomeBeneficiario: '',
            emailBeneficiario: '',
            telefoneBeneficiario: '',
            nomeInvalido: false,
            emailInvalido: false,
            telefoneInvalido: false,
            contatosInvalido: false,
            listaBeneficiario: [],
            limiteLista: [],
            modalMudarPlano: false,
            modalBeneficiarios: false,
            modalEscolherFrete: false,
            frete: undefined,
            mensagem: '',
            modalErroRenovacao: false,
            exibeInputsBeneficiario: false,
            naoTemCodMembro: true,
            exibeBeneficiarios: false,
        }

        this.Configurations = new Configurations();
        this.Geral = new Geral();


        this.productOptions = this.Geral.produtosMOCK.map(prod =>
        ({
            label: prod.nome,
            value: prod.idProduto,
            sigla: prod.sigla,
            tipoConteudo: prod.tipoConteudo
        }));

        this.quantityOptions = [];

        for (let x = 1; x <= 30; x++) {
            this.quantityOptions.push({ label: x, value: x });
        }

        this.planoOptions = [
            { label: "Individual", value: 2 },
            { label: "Familiar", value: 7 },
        ];

        this._phrases = {
            closeDatePicker: "Fechar",
            clearDates: "Limpar datas",
            calendarLabel: "Calendário"
        };

        this.formaPagamentoOptions = [
            { label: "Boleto", value: 2 },
            { label: "PIX", value: 10 },
        ]

        this.enderecoMOCK = {
            titulo: '',
            pais: "Brasil",
            cidade: "São Paulo",
            uf: "SP",
            bairro: "Vila Mariana",
            logradouro: "Rua Vergueiro",
            numero: '',
            complemento: '',
            cep: ''

        };

    }

    componentDidMount() {
        //querystring=paginacao
        const valor = qs.parse(window.location.search);
        const idPedido = parseInt(valor["?idPedido"]);
        if (!!idPedido) {
            this.verificaSeTemPedido(idPedido);
            this.setState({
                idPedidoRenovacao: idPedido
            });
        }
    }

    componentWillMount() {
        this.preparaNovoPedido();
    }

    handleInputChange(e, valueInputValor) {
        const _name = e.target.name,
            _value = e.target.name === "valorDesconto" ? valueInputValor : e.target.value;
        this.setState({ [_name]: _value })
    }


    carregaEdicoes() {
        this.setState({ isLoadingEdicoes: true })
        axios.get(this.Configurations.apiBasePath + `/edicoes/estoque/${this.state.idProduto.value}`).then(response => {
            this.setState({
                edicoesDisponiveis: response.data.edicoes.map(item => {
                    return { label: `Ed. ${item.edicao} - ${moment(item.dtEntrega).format('DD/MM/YYYY')}`, value: item.idEdicao, qtd: item.qtdDisponivel }
                })
            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingEdicoes: false }));
    }

    carregaEnderecos() {
        this.setState({ isLoadingEndereco: true })
        axios.get(this.Configurations.apiBasePath + `/enderecos/${this.state.infosSolicitante.idUsuario}`).then(response => {
            this.setState({ listaEnderecos: response.data.enderecos })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingEndereco: false }));
    }

    salvarEndereco(_end) {
        this.setState({ isLoadingEndereco: true })
        axios.post(this.Configurations.apiBasePath + `/enderecos/${this.state.infosSolicitante.idUsuario}`, _end).then(response => {
        }).catch(this.handleError).finally(() => {
            this.carregaEnderecos();
        });
    }
    validacaoBuscaSolicitante() {
        let campoVazio, primeiroCaracter, segundoCaracter;
        campoVazio = this.state.solicitanteBusca === '';
        if (campoVazio) {
            return false;
        } else {
            primeiroCaracter = this.state.solicitanteBusca[0] === 'm' || this.state.solicitanteBusca[0] === 'c';
            if (!primeiroCaracter) return false;
            else {
                segundoCaracter = parseInt(this.state.solicitanteBusca[1]);
                if (isNaN(segundoCaracter)) return false;
                else {
                    return true;
                }
            }
        }
    }

    buscaSolicitante() {
        if (!this.validacaoBuscaSolicitante()) {
            this.setState({ alertaBuscaSolicitante: true });
        }
        else {
            this.setState({ isLoadingBuscaSolicitante: true })
            axios.get(this.Configurations.apiBasePath + `/busca?query=${this.state.solicitanteBusca}`).then(response => {
                if (response.data.users.length !== 1 || response.data.users[0].permitirNovoPedido === false) {
                    this.setState({
                        alertaBuscaSolicitante: true
                    })
                }
                else {
                    this.setState({
                        buscaRealizada: true,
                        nomeBusca: response.data.users[0].nome,
                        idUsuarioBusca: response.data.users[0].idUsuario,
                        alertaBuscaSolicitante: false,
                        infosSolicitante: {
                            nome: response.data.users[0].nome,
                            codMembro: response.data.users[0].codMembro,
                            idUsuario: response.data.users[0].idUsuario,
                            codFamilia: response.data.users[0].codFamilia
                        }
                    }, () => {
                        this.setState({
                            enderecos: [],
                            opcaoEntrega: !!this.state.infosSolicitante.codMembro ? "2" : "1",
                            valorFrete: 0,
                            freteAtivo: false
                        }, () => {
                            this.carregaEnderecos();
                            this.calculaValorTotalPedido(this.state.pedido);
                        })
                    })
                }
            }).catch(this.handleError).finally(() => this.setState({ isLoadingBuscaSolicitante: false }));
        }
    }



    buscaAssinante() {
        this.setState({ isLoadingBuscaAssinante: true })
        axios.get(this.Configurations.apiBasePath + `/busca?query=${this.state.textoBuscaMembro}`).then(response => {
            if (response.data.users.length === 0) {
                this.setState({
                    alertaBuscaAssinante: true,
                    erroBuscaAssinante: "Membro não encontrado",
                    exibeAssinantes: false
                })
            }
            else {
                this.setState({
                    alertaBuscaAssinante: false,
                    erroBuscaAssinante: "",
                    listaAssinantes: []
                }, () => {
                    this.setState({
                        exibeAssinantes: true,
                        listaAssinantes: response.data.users
                    })
                })
            }
        }).catch(this.handleError).finally(() => this.setState({ isLoadingBuscaAssinante: false }));
    }

    buscaBeneficiario() {
        this.setState({ isLoadingBuscaBeneficiario: true })
        axios.get(this.Configurations.apiBasePath + `/busca?query=${this.state.textoBuscaBeneficiario}`).then(response => {
            if (response.data.users.length === 0) {
                this.setState({
                    alertaBuscaBeneficiario: true,
                    erroBuscaBeneficiario: "Beneficiário não encontrado",
                    exibeBeneficiarios: false
                })
            }
            else {
                this.setState({
                    alertaBuscaBeneficiario: false,
                    erroBuscaBeneficiario: "",
                    listaBeneficiarios: []
                }, () => {
                    this.setState({
                        exibeBeneficiarios: true,
                        listaBuscaBeneficiarios: response.data.users
                    })

                })
            }
        }).catch(this.handleError).finally(() => this.setState({ isLoadingBuscaBeneficiario: false }));
    }

    handleSelectChange(e, _name, o = null) {
        if (o && o.action === "clear") {
            this.setState({ [o.name]: null });
            return;
        }
        this.setState({ [_name]: { value: e.value, label: e.label } }, () => {
            if (_name === "idTipoPedido") {
                this.setState({ exibeSelectPeriodo: false })
                this.periodOptions = this.Geral.periodosMOCK[this.state.idProduto.sigla]
                    .filter(item => parseInt(item.idTipoPedido, 10) === parseInt(e.value, 10)).map(per =>
                        ({ label: per.periodo, value: per.idPeriodo, preco: per.valorTotal })
                    );

                this.setState({ periodOptions: this.periodOptions }, () => {
                    this.setState({ exibeSelectPeriodo: true })
                    this.handleSelectPeriodChange(null, { action: "clear", name: "idPeriodo" })
                })
            }
        })
    }

    handleSelectProductChange(e, _name, o = null) {
        if (o && o.action === "clear") {
            this.setState({ [o.name]: null });
            return;
        }
        if (this.state.listaBeneficiario.length > 0) {
            this.toggleMudarPlano();

        }
        this.setState({
            exibeSelectPeriodo: false,
            [_name]: {
                value: e.value,
                label: e.label,
                sigla: e.sigla
            },
            idTipoPedido: { value: 2, label: "Individual" },
            idPeriodo: null,
            qtdPedido: { value: 1, label: "1" }
        }, () => {


            if (this.verificaProdutoDigitalSelecionado(this.state.idProduto.value)) {
                this.setState({
                    opcaoVigencia: "estender",
                })
            }

            if (parseInt(this.state.idProduto.value, 10) !== 5) {

                this.periodOptions = this.Geral.periodosMOCK[this.state.idProduto.sigla].map(per =>
                    ({ label: per.periodo, value: per.idPeriodo, preco: per.valorTotal })
                );

                this.setState({ periodOptions: this.periodOptions }, () => {
                    this.setState({ exibeSelectPeriodo: true })
                    this.handleSelectPeriodChange(null, { action: "clear", name: "idPeriodo" })
                })
            }
        })
    }

    handleSelectPeriodChange(o, e,) {
        if (e.action === "clear") this.setState({ [e.name]: null })
        else this.setState({
            [e.name]: { value: o.value, label: o.label, preco: o.preco },
            idEdicao: undefined,
            alertaPeriodo: false
        }, () => {
            //-- Se for unitário, carrega as edições
            if (this.state.idPeriodo.value === 5) {
                this.carregaEdicoes();
            }
        })
    }

    selecionaAssinante(_infos, e) {
        if (e) e.preventDefault();
        this.setState({
            exibeProdutos: true,
            exibeAssinantes: false,
            infosAssinante: _infos
        })
    }

    selecionaBeneficiario(_infosBene, e) {
        if (e) e.preventDefault();
        this.setState({
            exibeProdutos: true,
            exibeBeneficiarios: false,
            infosBeneficiario: _infosBene,
            exibeInputsBeneficiario: true,
            nomeBeneficiario: _infosBene.nome
        })
    }

    habilitaAdicionarProduto() {
        let _digital = false;
        const _idProd = this.state.idProduto === null,
            _idPeriodo = this.state.idPeriodo === null,
            _idEdicao = this.state.idPeriodo && this.state.idPeriodo.value === 5 && (this.state.idEdicao === undefined || this.state.idEdicao === null);



        if (!!this.state.idProduto && this.verificaProdutoDigitalSelecionado(this.state.idProduto.value)) {
            _digital = this.state.idTipoPedido === null;
        }
        return _idProd || _idPeriodo || _digital || _idEdicao
    }
    calculaValorTotalPedido(_pedido) {

        const _subtotal = _pedido.reduce((acc, curValue) => acc + (Number.parseFloat(curValue.valorItem) * curValue.qtde), 0);
        const _valorTotal = _subtotal + this.state.valorFrete;

        this.setState({
            valorTotalPedido: _valorTotal,
            valorSubtotal: _subtotal
        }, () => {
            if (this.state.saldoAtual < _valorTotal) {
                this.setState({
                    valorMaxDesconto: this.state.saldoAtual
                })
            } else {
                this.setState({
                    valorMaxDesconto: _valorTotal
                })
            }
        })
    }

    calculaValorItem(preco, acresc, desc, percent) {

        preco = parseFloat(preco, 10);
        acresc = parseFloat(acresc, 10);
        desc = desc ? parseFloat(desc, 10) : 0;

        if (percent) return preco * (100 - desc) / 100 + acresc;
        else return (preco + acresc) - desc;

    }

    adicionarProduto() {
        this.setState({ isLoadingPedido: true })
        let _pedido = this.state.pedido;

        const _preco = Number.parseFloat(this.state.idPeriodo.preco),
            _acresc = Number.parseFloat(this.state.valorAcrescimo),
            _desc = Number.parseFloat(this.state.valorDesconto),
            _percent = this.state.opcaoDesconto === "percentual";
        // const _pedidoAux = this.state.pedido;
        const _podeAdicionar = true;

        if (!_podeAdicionar) {
            this.toggleErroItem("bm");
            this.setState({ isLoadingPedido: false })
        } else if (this.calculaValorItem(_preco, _acresc, _desc, _percent) >= 0) {
            _pedido.push({
                "codFamilia": this.state.infosAssinante.codFamilia,
                "idUsuario": this.state.infosAssinante.idUsuario,
                "nomeMembro": this.state.infosAssinante.nome,
                "codMembro": this.state.infosAssinante.codMembro,
                "idProduto": this.state.idProduto.value,
                "nomeProduto": this.state.idProduto.label,
                "siglaProduto": this.state.idProduto.sigla,
                "idPeriodo": this.state.idPeriodo.value,
                "idEdicao": this.state.idEdicao && this.state.idEdicao.value,
                "nomePeriodo": this.state.idPeriodo.label,
                "qtde": this.state.qtdPedido.value,
                "estender": this.state.opcaoVigencia === "estender",
                "desconto": { valor: _desc, percentual: _percent },
                "acrescimo": _acresc,
                "preco": _preco,
                "tipoConteudo": this.state.idProduto.tipoConteudo,
                "valorItem": this.calculaValorItem(_preco, _acresc, _desc, _percent),
                "listaBeneficiario": this.state.listaBeneficiario,
                "familiar": this.state.idProduto ?
                    parseInt(this.state.idProduto.value, 10) === 5 ?
                        parseInt(this.state.idTipoPedido.value, 10) === 7
                        : false
                    : false
            })
            this.setState({ pedido: [] }, () => {
                this.setState({
                    pedido: _pedido,
                    exibePedido: true,
                    isLoadingPedido: false,
                    listaBeneficiario: [],
                    nomeBeneficiario: '',
                    emailBeneficiario: '',
                    telefoneBeneficiario: '',
                    limiteBeneficiariosMaximo: '',
                    beneficiarioExistente: '',

                }, () => {
                    if (this.verificaDigital()) {
                        this.setState({ opcaoEntrega: "2" })
                        this.calculaValorTotalPedido(this.state.pedido);
                    } else if (parseInt(this.state.opcaoEntrega, 10) === 1 && this.state.freteAtivo) {
                        // this.calcularFrete(this.state.cepFrete, this.state.idEnderecoSelecionado);
                        this.setState({ valorFrete: 0, freteAtivo: false })
                    } else this.calculaValorTotalPedido(this.state.pedido);
                    this.scrollPedido();
                });
            })
        } else {
            this.toggleErroItem();
            this.setState({ isLoadingPedido: false })
        }
    }

    scrollPedido() {
        var element = document.getElementById("tabela-pedido");
        element.scrollIntoView({ block: "end", behavior: "smooth" });
    }

    excluirItem(_index) {
        const itemPedido = this.state.pedido[_index];
        const valorRestituicao = this.state.saldoOriginal > 0 ? itemPedido.desconto.valor * itemPedido.qtde : 0;
        const novoPedido = update(this.state.pedido, { $splice: [[_index, 1]] });
        this.setState({
            pedido: novoPedido,
            exibePedido: true,
            isLoadingPedido: false,
            saldoAtual: valorRestituicao + this.state.saldoAtual
        }, () => {
            if (this.verificaDigital()) {
                this.setState({ opcaoEntrega: "2", valorFrete: 0, freteAtivo: false });
                this.calculaValorTotalPedido(this.state.pedido);
            } else if (parseInt(this.state.opcaoEntrega, 10) === 1 && this.state.freteAtivo) {
                // this.calcularFrete(this.state.cepFrete, this.state.idEnderecoSelecionado);
            } else this.calculaValorTotalPedido(this.state.pedido);
        });
    }

    productBadgeType(_idProd) {
        switch (_idProd.toString()) {
            case "1":
                return "primary";
            case "2":
                return "success";
            case "3":
                return "danger";
            case "4":
                return "warning";
            default:
                return "info";
        }
    }

    handleRadio(e) {
        this.setState({
            [e.target.name]: e.target.value
        }, () => {
            if (this.state.opcaoEntrega === "2") {
                this.setState({ valorFrete: 0, freteAtivo: false, 
                    idTipoFreteSelecionado: 2 // entrega na organização de base
                 }, () => this.calculaValorTotalPedido(this.state.pedido))
            }
        });
    }

    finalizarPedido() {
        if (!this.habilitaFinalizarPedido()) {
            this.setState({ isLoadingFinalizaPedido: true, exibePedidoFinal: true })

            const _pedidoCompleto = {
                idSolicitante: this.state.idUsuarioBusca,
                idTipoPedido: 2, //individual
                // idTipoEntrega: parseInt(this.state.opcaoEntrega, 10),
                idTipoEntrega: this.state.idTipoFreteSelecionado,

                itens: this.state.pedido,
                entrega: {
                    idEndereco: this.state.idEnderecoSelecionado,
                    valorFrete: this.state.valorFrete,
                }
            }

            axios.post(this.Configurations.apiBasePath + `/pedidos`, _pedidoCompleto).then(response => {
                this.props.history.push(`/pedidos/detalhes/${response.data.pedido.idPedido}`)
            }).catch(err => {
                this.handleError(err);
                this.setState({ erroPedido: true });
            }).finally(() => this.setState({ isLoadingFinalizaPedido: false }));
        }
    }

    //TODO: REMOVE
    enviarEmail() {
        const body = { email: this.state.email, idUsuario: this.state.idUsuarioBusca, enviarEmail: this.state.enviarBoleto };

        axios.post(`${this.Configurations.apiBasePath}/pedidos/${this.state.pedidoNumero}/email`, body)
            .then(response => {
                this.setState({
                    erroEmail: false,
                    emailEnviado: true
                });
            })
            .catch(err => {
                console.log(err);
                this.setState({ erroEmail: true });
            })
            .finally(() => {
                this.setState({ isLoadingEmail: false });
                this.toggleEmail();
            });
    }

    preparaNovoPedido() {
        const initialState = {
            codMembroBusca: '',
            idUsuarioBusca: null,
            nomeBusca: '',
            buscaRealizada: false,

            infosAssinante: null,

            textoBuscaMembro: '',
            textoBuscaBeneficiario: '',

            isLoading: false,
            isLoadingBuscaAssinante: false,
            isLoadingBuscaBeneficiario: false,

            isLoadingBuscaSolicitante: false,
            isLoadingFinalizaPedido: false,
            isLoadingPedido: false,
            isLoadingBoleto: false,
            isLoadingFrete: false,
            isLoadingEndereco: false,

            exibeAssinantes: false,
            exibeBeneficiarios: false,

            exibeProdutos: false,
            exibePedido: false,
            exibeSelectPeriodo: false,

            sigla: null,
            idProduto: null,
            idPeriodo: null,
            qtdPedido: { value: 1, label: "1" },
            pedido: [],
            listaAssinantes: [],
            listaBeneficiarios: [],


            alertaPeriodo: false,
            alertaBuscaSolicitante: false,
            alertaBuscaAssinante: false,
            alertaBuscaBeneficiario: false,

            erroBuscaAssinante: '',
            erroBuscaBeneficiario: '',


            opcaoVigencia: "estender",
            opcaoDesconto: "percentual",
            valorDesconto: 0,
            valorAcrescimo: 0,

            opcaoEntrega: "2",
            // opcaoEntrega: "1",

            pedidoMensagem: '',
            pedidoSucesso: false,
            pedidoNumero: '',
            erroPedido: false,
            exibePedidoFinal: false,

            periodOptions: [],

            email: '',

            modalEmail: false,
            modalBoleto: false,
            dtVencimentoBoleto: null,
            erroBoleto: false,
            erroEmail: false,
            emailEnviado: false,
            enviarBoleto: false,

            temBoleto: false,

            valorSubtotal: 0,
            valorFrete: 0,
            valorTotalPedido: 0,

            freteAtivo: false,

            modalErroItem: false,
            msgErroItem: '',

            listaEnderecos: [],
            mensagem: '',
            loadingBeneficiario: false,
            loadingPedido: false,
        }
        this.setState(initialState);
    }



    toggleEmail() { this.setState({ modalEmail: !this.state.modalEmail }) }
    toggleBoleto() { this.setState({ modalBoleto: !this.state.modalBoleto }) }

    onDateChange(date) { this.setState({ dtVencimentoBoleto: date }) }
    onFocusChange(objFocused) { this.setState(objFocused) }

    //TODO: REMOVE
    enviarBoletoAnexo() {
        this.setState({ enviarBoleto: !this.state.enviarBoleto });
    }

    _outsideRange(day) {
        return day.format() < moment().format();
    }

    mudaTemBoleto() {
        this.setState({ temBoleto: !this.state.mudaTemBoleto })
    }

    calcularFrete(_cep, _idEnd) {
        const _bodyFrete = {
            cepFrete: _cep,
            itensPedido: this.state.pedido.map(ped => ({
                idUsuario: ped.idUsuario,
                idPeriodo: ped.idPeriodo,
                idProduto: ped.idProduto,
                qtde: ped.qtde
            }))
        }
        this.setState({ isLoadingFrete: true })
        axios.post(this.Configurations.apiBasePath + `/calcula-frete`, _bodyFrete).then(response => {
            this.setState({
                cepFrete: response.data.cepFrete,
                mensagem: response.data.message,
                tipoFrete: response.data.fretes,
                idEnderecoSelecionado: _idEnd,
            }, () => {
                this.calculaValorTotalPedido(this.state.pedido);
                if (this.state.valorFrete > 0) this.toggleFrete(true);
                else this.setState({ freteAtivo: false });
                if (!!this.state.tipoFrete) this.toggleModalEscolherFrete();
            })

        }).catch(this.handleError).finally(() => this.setState({ isLoadingFrete: false }));

    }

    habilitaFinalizarPedido() {
        const _pedidoValido = this.state.pedido.length > 0,
            _entregaValida = this.state.opcaoEntrega === "2" ? true : this.state.freteAtivo ? true : false;
        return !(_pedidoValido * _entregaValida);
    }

    desabilitaOpcaoVigencia() {
        if (this.state.idProduto === null) return false;
        else if (this.verificaProdutoDigitalSelecionado(this.state.idProduto.value))
            return true;
        else return false;
    }

    desabilitaOpcaoEntrega() {
        if (this.state.idProduto === null) return false;
        else if (this.verificaProdutoDigitalSelecionado(this.state.idProduto.value))
            return true;
        else return false;
    }

    toggleFrete(_flag) {
        this.setState({ freteAtivo: _flag }, () => {
            if (!_flag) this.setState({ valorFrete: 0 },
                () => this.calculaValorTotalPedido(this.state.pedido))
        })
    }

    toggleErroItem(sigla = null) {
        this.setState({
            modalErroItem: !this.state.modalErroItem,
            msgErroItem: sigla === "bm" ? <p>O produto <strong>BS+</strong> não permite adicionar: <ul><li>mais de um plano individual para a mesma pessoa;</li><li>planos familiar e individual simultaneamente para a mesma família.</li></ul></p> : <p>O desconto não pode ser maior que o valor do item.</p>
        })
    }

    verificaDigital() {
        const _soDigital = this.state.pedido.filter(item => this.verificaProdutoDigitalSelecionado(item.idProduto)).length === this.state.pedido.length
        return _soDigital;
    }

    buscaCEP(_cep) {

    }

    filterPlano(item) {
        if (!!this.state.infosAssinante.codMembro) {
            return true;
        } else {
            return item.value !== 7
        }

    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }

    closeErrorModal() {
        this.setState({ hasError: false, errorMessage: "" })
    }

    utilizarSaldo() {
        if (!this.state.flagUtilizarSaldo) {
            this.setState({
                opcaoDesconto: "absoluto",
                valorDesconto: this.state.saldoAtual.toFixed(2).toString().replace(".", ","),
                flagUtilizarSaldo: true
            })
        } else {
            this.setState({
                opcaoDesconto: "absoluto",
                valorDesconto: 0,
                flagUtilizarSaldo: false
            })
        }
    }

    inserirDescontoPedido(desc) {
        let _descAux = desc;
        const _pedidoAlterado = this.state.pedido.map(item => {
            const _valorDesconto = item.valorItem * item.qtde <= _descAux ? item.valorItem : _descAux / item.qtde;
            if (_descAux <= 0) {
                return item
            } else {
                _descAux = _descAux - _valorDesconto * item.qtde;
                return {
                    ...item, desconto: { valor: _valorDesconto, percentual: false },
                    valorItem: this.calculaValorItem(item.preco, item.acrescimo, _valorDesconto, false)
                }
            }
        })

        this.setState({
            pedido: _pedidoAlterado
        }, () => this.calculaValorTotalPedido(this.state.pedido))

        this.setState({
            saldoAtual: this.state.saldoAtual - desc
        })
    }

    verificaProdutoDigitalSelecionado(idProduto) {
        if (!idProduto) {
            return false;
        }
        const produtoSelecionado = this.Geral.produtosMOCK.filter(item => {
            return parseInt(item.idProduto, 10) === parseInt(idProduto, 10)
        });

        if (parseInt(produtoSelecionado[0].idTipoProduto, 10) === 3) {
            return true;

        }
        else return false;
    }

    handleOnChange(e) {
        e.preventDefault();
        const _name = e.target.name, _value = e.target.value;
        this.setState({ [_name]: _value })
    }


    validacaoEmail(inputEmail) {
        const _usuario = inputEmail.substring(0, inputEmail.indexOf("@"));
        const _dominio = inputEmail.substring(inputEmail.indexOf("@") + 1, inputEmail.length);

        if ((_usuario.length >= 1) &&
            (_dominio.length >= 3) &&
            (_usuario.search("@") === -1) &&
            (_dominio.search("@") === -1) &&
            (_usuario.search(" ") === -1) &&
            (_dominio.search(" ") === -1) &&
            (_dominio.search(".") !== -1) &&
            (_dominio.indexOf(".") >= 1) &&
            (_dominio.lastIndexOf(".") < _dominio.length - 1)) {
            return true;
        }
        else return false;
    }

    validacaoTelefone(inputTelefone) {
        const _telNum = inputTelefone.replace(/\D+/g, '');
        return _telNum.length >= 11;
    }

    salvarBeneficiario() {
        const _nomeValido = this.state.nomeBeneficiario.trim() !== '' && this.state.nomeBeneficiario.trim().length >= 3;
        if (_nomeValido) {

            let _emailValido = this.state.emailBeneficiario.trim() !== '';
            if (_emailValido) {
                _emailValido = this.validacaoEmail(this.state.emailBeneficiario)


            }
            const _emailExistente = this.state.listaBeneficiario.filter(item => {
                return item.email === this.state.emailBeneficiario
            });

            let _telefoneValido = this.state.telefoneBeneficiario.trim !== '';
            if (_telefoneValido) {
                _telefoneValido = this.validacaoTelefone(this.state.telefoneBeneficiario)
            }

            const _beneficiarioExistente = _emailExistente.length > 0;
            this.setState({
                emailInvalido: this.state.emailBeneficiario.trim() !== '' && !_emailValido,
                telefoneInvalido: this.state.telefoneBeneficiario.trim() !== '' && !_telefoneValido,
                contatosInvalido: this.state.emailBeneficiario.trim() === '' && this.state.telefoneBeneficiario.trim() === '',
                nomeInvalido: false,
            }, () => {
                if (!this.state.emailInvalido * !this.state.telefoneInvalido * !this.state.contatosInvalido * !this.state.nomeInvalido) {
                    let limiteLista;
                    if (parseInt(this.state.idProduto.value, 10) === 10) {
                        limiteLista = 1;
                    }
                    if (parseInt(this.state.idProduto.value, 10) === 11) {
                        limiteLista = 3;
                    }

                    this.setState({
                        limiteBeneficiariosMaximo: this.state.listaBeneficiario.length === limiteLista
                    }, () => {

                        if (!this.state.limiteBeneficiariosMaximo) {
                            if (_beneficiarioExistente) {
                                this.setState({
                                    beneficiarioExistente: true
                                })
                            }
                            else {
                                const objBeneficiario = {
                                    nomePresenteado: this.state.nomeBeneficiario,
                                    emailPresenteado: this.state.emailBeneficiario,
                                    celularPresenteado: this.state.telefoneBeneficiario,
                                    cpfPresenteado: null
                                }
                                let _array = this.state.listaBeneficiario;
                                _array.push(objBeneficiario);
                                this.setState({
                                    listaBeneficiario: _array,
                                }, () => this.setState({
                                    nomeBeneficiario: '',
                                    emailBeneficiario: '',
                                    telefoneBeneficiario: '',
                                    beneficiarioExistente: false,
                                    infosBeneficiario: undefined,
                                    exibeInputsBeneficiario: false

                                }))

                            }
                        }
                    }
                    )
                }
            })
        }
        else {

            this.setState({
                nomeInvalido: true,
                emailInvalido: false,
                telefoneInvalido: false,
                contatosInvalido: false
            })
        }
    }

    toggleMudarPlano() {
        this.setState({
            modalMudarPlano: !this.state.modalMudarPlano,

        })
    }

    botaoConfirmar() {
        this.setState({
            nomeBeneficiario: '',
            emailBeneficiario: '',
            telefoneBeneficiario: '',
            limiteBeneficiariosMaximo: '',
            listaBeneficiario: [],
            modalMudarPlano: !this.state.modalMudarPlano
        })
    }

    excluirBeneficiario(posicao) {
        let _array = this.state.listaBeneficiario;
        _array.splice(posicao, 1)
        this.setState({
            listaBeneficiario: _array
        })
    }

    toggleModalBeneficiarios(index) {
        this.setState({
            indexBeneficiario: index
        }, () => {
            this.setState({
                modalBeneficiarios: !this.state.modalBeneficiarios
            })
        })
    }


    toggleModalEscolherFrete() {
        this.setState({
            modalEscolherFrete: !this.state.modalEscolherFrete,
        })
    }

    handleRadioFrete(e) {
        this.setState({ idTipoFreteSelecionado: Number(e.target.value) })
    }

    incluirFrete() {
        const objetoFreteSelecionado = this.state.tipoFrete.filter(item => item.idTipoEntrega === this.state.idTipoFreteSelecionado)[0]
        this.setState({
            valorFrete: objetoFreteSelecionado.valor, freteAtivo: true
        }, () => this.calculaValorTotalPedido(this.state.pedido))
        this.toggleModalEscolherFrete();
    }

    calcularPrazo() {
        window.open('https://www2.correios.com.br/sistemas/precosPrazos/')
    }

    verificaSeTemPedido(idPedido) {
        //     A solução com Promise foi feita com o intuito de economizar recurso de desenvolvimento nas apis do Fukyo. 
        //     O risco foi assumido pois os cenários em que essa solução não seria adequada são muito atípicos. 
        //     Num futuro, pode haver a nacessidade de revisão.
        this.setState({ loadingPedido: true });
        axios.get(this.Configurations.apiBasePath + `/pedidos/${idPedido}`).then(response => {
            const itens = response.data.data.itens;
            this.setState({
                idSolicitante: response.data.data.idSolicitante,
                solicitanteBusca: `m${response.data.data.codMembroSolicitante}`
            });

            const promises = itens.map(async item => {
                const valorProduto = this.trazerValorProduto(item.sigla, item.idPeriodo);
                const listaBeneficiario = item.temBeneficiario ? await this.chamarApiBeneficiario(item.idItem) : [];

                return {
                    idUsuario: item.idUsuario,
                    nomeMembro: item.membro,
                    codMembro: item.codMembro,
                    idProduto: item.idProduto,
                    nomeProduto: item.produto,
                    siglaProduto: item.sigla,
                    idPeriodo: item.idPeriodo,
                    nomePeriodo: item.periodo,
                    qtde: item.qtd,
                    estender: true,
                    desconto: { "valor": item.desconto, "percentual": false },
                    acrescimo: item.acrescimo,
                    preco: valorProduto,
                    valorItem: valorProduto,
                    listaBeneficiario: listaBeneficiario.length > 0 ? listaBeneficiario.map(beneficiario => ({
                        confirmacaoAutomatica: true,
                        idUsuarioConfirmado: beneficiario.idUsuarioConfirmado,
                        celularPresenteado: beneficiario.celularPresenteado,
                        cpfPresenteado: beneficiario.cpfPresenteado,
                        emailPresenteado: beneficiario.emailPresenteado,
                        flagAssinaturaAceita: beneficiario.flagAssinaturaAceita,
                        idItemBeneficiario: beneficiario.idItemBeneficiario,
                        idSolicitante: beneficiario.idSolicitante,
                        idSolicitanteInduzido: beneficiario.idSolicitanteInduzido,
                        nomePresenteado: beneficiario.nomePresenteado,
                        codMembro: beneficiario.codMembro,
                        origemRegistro: beneficiario.origemRegistro
                    })) : [],
                    familiar: item.familiar,
                    tipoConteudo: item.tipoConteudo,
                };
            });
            return Promise.all(promises);
        }).then(pedido => {
            return new Promise((resolve) => {
                this.setState({
                    pedido: pedido,
                    buscaRealizada: true,
                    exibeProdutos: true,
                    exibePedido: true,
                }, () => {
                    this.calculaValorTotalPedido(this.state.pedido);
                    resolve();
                });
            });
        }).then(() => {
            this.buscaSolicitante();
        }).catch(this.handleError).finally(() => {
            this.setState({ loadingPedido: false }, () => {
                if (this.state.erroRenovacao) {
                    this.toggleErroRenovacao();
                }
                if (this.state.pedido.length > 0) {
                    this.scrollPedido();
                }
            });
        });
    }

    chamarApiBeneficiario(idItem) {
        this.setState({ loadingBeneficiario: true })
        return axios.get(this.Configurations.apiBasePath + `/pedidos/${idItem}/beneficiarios`).then(response =>
            response.data.beneficiario
        ).catch(this.handleError).finally(() => this.setState({ loadingBeneficiario: false }));
    }

    trazerValorProduto(sigla, idPeriodo) {
        const arrayPeriodo = this.Geral.periodosMOCK[sigla].filter(per => per.idPeriodo === idPeriodo);
        if (arrayPeriodo.length === 0) {
            this.setState({
                erroRenovacao: true
            });
            return undefined;
        }
        return parseFloat(arrayPeriodo[0].valorTotal);
    }

    toggleErroRenovacao() {
        this.setState({
            modalErroRenovacao: !this.state.modalErroRenovacao
        });
    }

    aumentaQtde(index) {
        this.setState({
            pedido: update(this.state.pedido, { [index]: { qtde: { $set: this.state.pedido[index].qtde + 1 } } })
        }, () => this.calculaValorTotalPedido(this.state.pedido))
    }

    diminueQtde(index) {
        if (this.state.pedido[index].qtde > 1) {
            this.setState({
                pedido: update(this.state.pedido, { [index]: { qtde: { $set: this.state.pedido[index].qtde - 1 } } })
            }, () => this.calculaValorTotalPedido(this.state.pedido))
        }
    }

    semCodMembro() {
        this.setState({
            exibeInputsBeneficiario: true,
            naoTemCodMembro: false
        })
    }

    render() {
        return (
            <div className="row new-order mb-3 no-gutters">
                <div className='col-12'>
                    {/* <div className="row mb-3 no-gutters text-center"> */}
                    {(this.state.loadingPedido || this.state.loadingBeneficiario) ? (
                        // {(true || this.state.loadingBeneficiario) ? (
                        <div className='row no-gutters'>
                            <div className='col-12 text-center'>
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        </div>
                    ) : (
                        [<HeaderPedido
                            key={"header"}
                            valorSubtotal={this.state.valorSubtotal}
                            freteAtivo={this.state.freteAtivo}
                            opcaoEntrega={this.state.opcaoEntrega}
                            valorFrete={this.state.valorFrete}
                            valorTotalPedido={this.state.valorTotalPedido}
                            habilitaFinalizarPedido={this.habilitaFinalizarPedido}
                            finalizarPedido={this.finalizarPedido}
                            saldoAtual={this.state.saldoAtual}
                            saldoOriginal={this.state.saldoOriginal}
                            inserirDescontoPedido={this.inserirDescontoPedido}
                            saldoAtualizado={this.state.saldoAtualizado}
                            valorMaxDesconto={this.state.valorMaxDesconto}
                            isLoadingFinalizaPedido={this.state.isLoadingFinalizaPedido}
                        />,
                        <div key={"pedido"} className="div-pedido mb-3">
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12">
                                        <h2>Novo Pedido</h2>
                                    </div>
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body px-1">
                                                <div className="row align-items-center px-3 no-gutters">
                                                    <div className="col-12">
                                                        <form className="form-inline">
                                                            <div className="form-group">
                                                                <label className="mr-3" htmlFor="solicitante">Solicitante:</label>
                                                                <input id="solicitante" name="solicitanteBusca" className="mr-3 form-control text-center" type="text" value={this.state.solicitanteBusca} onChange={this.handleInputChange} placeholder="cód. de membro ou cpf" />
                                                            </div>

                                                            {this.state.isLoadingBuscaSolicitante ? (
                                                                <div className="spinner-border text-primary" role="status" />
                                                            ) : (
                                                                <button disabled={!this.state.solicitanteBusca || this.state.solicitanteBusca.trim() === ""} onClick={this.buscaSolicitante} className="btn btn-outline-secondary">buscar</button>
                                                            )}
                                                            {this.state.alertaBuscaSolicitante && (
                                                                <span className="text-danger ml-4">Busca inválida</span>
                                                            )}
                                                            {(this.state.buscaRealizada && !this.state.alertaBuscaSolicitante) && (
                                                                [<span key={`span`} className="nome-responsavel m-0 p-0 mx-4">{this.state.nomeBusca}</span>,
                                                                ]
                                                            )}
                                                        </form>
                                                    </div>
                                                    <div className="col-12">
                                                        <p className="my-2"><small>Para busca por código de membro, insira primeiro a letra 'm'. Ex: m4567. </small></p>
                                                        <p className="my-2"><small>Para busca por cpf, insira primeiro a letra 'c'. Ex: c12345678910. </small></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.buscaRealizada && !this.state.alertaBuscaSolicitante && (
                                        <div className="col-12">
                                            <div className="card">
                                                <div className="card-body px-1">
                                                    <div className="row no-gutters">
                                                        <div className="col-12">
                                                            <div className="row px-3 align-items-center no-gutters">
                                                                <div className="col-12">
                                                                    <form className="form-inline">
                                                                        <div className="form-group">
                                                                            <label className="mr-3" htmlFor="buscaAssinante">Assinante:</label>
                                                                            <input id="buscaAssinante" name="textoBuscaMembro" className="mr-3 form-control text-center" type="text" value={this.state.textoBuscaMembro} onChange={this.handleInputChange} placeholder="nome ou cód. membro" />
                                                                        </div>
                                                                        {this.state.isLoadingBuscaAssinante ? (
                                                                            <div className="spinner-border text-primary" role="status" />
                                                                        ) : (
                                                                            <button onClick={this.buscaAssinante} className="btn btn-outline-secondary">buscar</button>
                                                                        )}
                                                                        {this.state.alertaBuscaAssinante && (
                                                                            <span className="text-danger ml-4">{this.state.erroBuscaAssinante}</span>
                                                                        )}
                                                                        {(this.state.buscaRealizada && !this.state.alertaBuscaSolicitante) && (
                                                                            [
                                                                                <button key={`btn`} onClick={(e) => this.selecionaAssinante(this.state.infosSolicitante, e)} className="mx-4 btn btn-outline-info">o solicitante é o assinante</button>
                                                                            ]
                                                                        )}
                                                                    </form>
                                                                </div>
                                                                <div className="col-12">
                                                                    <p className="my-2"><small>Para busca por código de membro, insira primeiro a letra 'm'. Ex: m4567.</small></p>
                                                                    <p className="my-2"><small>Para busca por cpf, insira primeiro a letra 'c'. Ex: c12345678910. </small></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {this.state.exibeAssinantes && (
                                                            <div className="col-12 text-center py-3">
                                                                <div className="row px-3 no-gutters">
                                                                    <div className="col-12 py-2">
                                                                        <TableClients
                                                                            listaBuscaMembro={this.state.listaAssinantes}
                                                                            pages={this.state.pages}
                                                                            loading={this.state.loadingTableClients}
                                                                            selecionaAssinante={this.selecionaAssinante}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {this.state.exibeProdutos && (
                                        <div className="col-12">
                                            <div className="card">
                                                <div className="card-body px-1">
                                                    <div className="row no-gutters">
                                                        <div className="col-12 px-3">
                                                            {this.state.infosAssinante && (
                                                                <p>Você está adicionando itens para <strong>{this.state.infosAssinante.nome}</strong></p>
                                                            )}
                                                        </div>
                                                        <div className="col-5 px-3">
                                                            <div className="form-group m-0">
                                                                <label htmlFor="ddlProducts">Produto</label>
                                                                <Select
                                                                    id="ddlProducts"
                                                                    placeholder="Selecione um produto"
                                                                    closeMenuOnSelect={true}
                                                                    components={makeAnimated()}
                                                                    options={this.productOptions}
                                                                    onChange={(e, o) => this.handleSelectProductChange(e, "idProduto", o)}
                                                                    name="idProduto"
                                                                    isClearable
                                                                />
                                                            </div>
                                                        </div>
                                                        {this.state.idProduto !== null && parseInt(this.state.idProduto.value, 10) === 5 && (
                                                            <div className="col-3 px-3">
                                                                <div className="form-group m-0">
                                                                    <label htmlFor="ddlPlanos">Plano</label>
                                                                    <Select
                                                                        id="ddlPlanos"
                                                                        placeholder="Selecione um plano"
                                                                        closeMenuOnSelect={true}
                                                                        components={makeAnimated()}
                                                                        options={this.planoOptions.filter(this.filterPlano)}
                                                                        onChange={(e, o) => this.handleSelectChange(e, "idTipoPedido", o)}
                                                                        name="idTipoPedido"
                                                                        isClearable
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                        {this.state.idProduto !== null && this.state.exibeSelectPeriodo && (
                                                            <div className={`col-4 px-3`}>
                                                                <div className="form-group m-0">
                                                                    <label htmlFor="ddlPeriods">Período</label>
                                                                    <Select
                                                                        id="ddlPeriods"
                                                                        placeholder="Selecione um período"
                                                                        closeMenuOnSelect={true}
                                                                        components={makeAnimated()}
                                                                        options={this.state.periodOptions}
                                                                        onChange={(o, e) => this.handleSelectPeriodChange(o, e)}
                                                                        name="idPeriodo"
                                                                        isClearable
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                        {this.state.idProduto !== null && !this.verificaProdutoDigitalSelecionado(this.state.idProduto.value) && (
                                                            <div className="col-2 px-3">
                                                                <div className="form-group m-0">
                                                                    <label htmlFor="ddlQuantity">Quantidade</label>
                                                                    <Select
                                                                        id="ddlQuantity"
                                                                        placeholder=""
                                                                        defaultValue={this.quantityOptions[0]}
                                                                        closeMenuOnSelect={true}
                                                                        components={makeAnimated()}
                                                                        options={this.quantityOptions}
                                                                        onChange={e => this.handleSelectChange(e, "qtdPedido")}
                                                                        name="qtdPedido"
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div className="col-12 py-2 text-center">
                                                            {this.state.alertaPeriodo && (
                                                                <small className="text-danger m-0">Período não disponível para esse produto.</small>
                                                            )}
                                                        </div>
                                                        <div className='col-12 py-3'>
                                                            {this.state.buscaRealizada && !this.state.alertaBuscaBeneficiario && this.state.idProduto !== null && (parseInt(this.state.idProduto.value, 10) === 10 || parseInt(this.state.idProduto.value, 10) === 11) && (
                                                                <div className="row no-gutters">
                                                                    <div className="col-12">
                                                                        <div className="row px-3 align-items-center no-gutters">
                                                                            <div className="col-12">
                                                                                <form className="form-inline">
                                                                                    <div className="form-group">
                                                                                        <label className="mr-3" htmlFor="buscaBeneficiario">Beneficiário:</label>
                                                                                        <input id="buscaBeneficiario" name="textoBuscaBeneficiario" className="mr-3 form-control text-center" type="text" value={this.state.textoBuscaBeneficiario} onChange={this.handleInputChange} placeholder="nome ou cód. membro" />
                                                                                    </div>
                                                                                    {this.state.isLoadingBuscaBeneficiario ? (
                                                                                        <div className="spinner-border text-primary" role="status" />
                                                                                    ) : (
                                                                                        <button onClick={this.buscaBeneficiario} className="btn btn-outline-secondary">buscar</button>
                                                                                    )}
                                                                                    {this.state.alertaBuscaBeneficiario && (
                                                                                        <span className="text-danger ml-4">{this.state.erroBuscaBeneficiario}</span>
                                                                                    )}
                                                                                    {/* {(this.state.buscaRealizada && !this.state.alertaBuscaBeneficiario) && ( */}
                                                                                    {this.state.naoTemCodMembro && (
                                                                                        <React.Fragment>
                                                                                            <button onClick={this.semCodMembro} className="mx-4 btn btn-outline-info">não tem cód. membro</button>
                                                                                        </React.Fragment>
                                                                                    )}
                                                                                    {/* )} */}
                                                                                </form>
                                                                            </div>
                                                                            <div className="col-12">
                                                                                <p className="my-2"><small>Para busca por código de membro, insira primeiro a letra 'm'. Ex: m4567.</small></p>
                                                                                <p className="my-2"><small>Para busca por cpf, insira primeiro a letra 'c'. Ex: c12345678910. </small></p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {this.state.exibeBeneficiarios && (
                                                                        <div className="col-12 text-center py-3">
                                                                            <div className="row px-3 no-gutters">
                                                                                <div className="col-12 py-2">
                                                                                    <TableClients
                                                                                        listaBuscaMembro={this.state.listaBuscaBeneficiarios}
                                                                                        pages={this.state.pages}
                                                                                        loading={this.state.loadingTableClients}
                                                                                        selecionaAssinante={this.selecionaBeneficiario}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>

                                                        {this.state.exibeInputsBeneficiario && (
                                                            <div className='col-12'>
                                                                {this.state.idProduto !== null && (parseInt(this.state.idProduto.value, 10) === 10 || parseInt(this.state.idProduto.value, 10) === 11) && (
                                                                    <div className="col-12 px-3">
                                                                        <p>Preencher nome e pelo menos um dos contatos</p>
                                                                        <div className='row no-gutters'>
                                                                            <div className="col-5 px-1">
                                                                                <label>Nome</label>
                                                                                {this.state.infosBeneficiario ? (
                                                                                    <p className='m-0 pt-2'><strong>{this.state.infosBeneficiario.nome}</strong></p>
                                                                                ) : (
                                                                                    <input type="text" name="nomeBeneficiario" className="form-control" value={this.state.nomeBeneficiario} onChange={this.handleOnChange} placeholder='Nome completo do beneficiário' autoComplete="disabled" />
                                                                                )}
                                                                            </div>
                                                                            <div className="col-3 px-1">
                                                                                <label>E-mail</label>
                                                                                <input type="email" name="emailBeneficiario" className="form-control" value={this.state.emailBeneficiario} onChange={this.handleOnChange} placeholder='usuario@dominio.com.br' autoComplete="disabled" />
                                                                            </div>
                                                                            <div className="col-2 px-1">
                                                                                <label>Celular</label>
                                                                                <InputMask
                                                                                    type="tel"
                                                                                    className="form-control"
                                                                                    maskChar=""
                                                                                    mask="(99)99999-9999"
                                                                                    id="telefoneBeneficiario"
                                                                                    name="telefoneBeneficiario"
                                                                                    placeholder="(99)99999-9999"
                                                                                    value={this.state.telefoneBeneficiario}
                                                                                    onChange={this.handleOnChange}
                                                                                    autoComplete="disabled"
                                                                                />
                                                                            </div>
                                                                            <div className='col-2 px-2 text-center align-items-end d-flex'>
                                                                                <button className='btn btn-sm btn-outline-success' onClick={this.salvarBeneficiario} disabled={this.state.emailBeneficiario.trim() === '' && this.state.telefoneBeneficiario.trim() === ''}>Adicionar beneficiário</button>
                                                                            </div>
                                                                            <div className='col-12'>
                                                                                <div className='row no-gutters'>
                                                                                    <div className='col-4'>
                                                                                        {this.state.nomeInvalido && (
                                                                                            <span className="text-danger mr-3 ml-3"><i>Preencher nome</i></span>
                                                                                        )}
                                                                                    </div>
                                                                                    <div className='col-4 text-center'>
                                                                                        {this.state.emailInvalido && (
                                                                                            <span className="text-danger mr-3 ml-3"><i>Preencher email válido</i></span>
                                                                                        )}
                                                                                    </div>
                                                                                    <div className='col-4'>
                                                                                        {this.state.telefoneInvalido && (
                                                                                            <span className="text-danger mr-3 ml-3"><i>Preencher telefone válido</i></span>
                                                                                        )}
                                                                                    </div>
                                                                                    <div className='col-4'>
                                                                                        {this.state.contatosInvalido && (
                                                                                            <span className="text-danger mr-3 ml-3"><i>Preencher pelo menos um contato válido</i></span>
                                                                                        )}
                                                                                    </div>
                                                                                    <div className='col-12'>
                                                                                        {this.state.limiteBeneficiariosMaximo && (
                                                                                            <h5 className='text-danger text-center py-3'>Não é possível adicionar mais beneficiários para o plano selecionado</h5>
                                                                                        )}
                                                                                    </div>
                                                                                    <div className='col-12'>
                                                                                        {this.state.beneficiarioExistente && (
                                                                                            <h5 className='text-danger text-center py-3'>Não é possível adicionar o mesmo beneficiário</h5>
                                                                                        )}
                                                                                    </div>

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                        {!!this.state.idProduto && this.state.idProduto !== null && (parseInt(this.state.idProduto.value, 10) === 10 || parseInt(this.state.idProduto.value, 10) === 11) && (
                                                            <div className='col-12 py-5 px-3 text-center'>
                                                                <h6>Lista de Beneficiários</h6>
                                                                <table className="table w-100 text-left table-bordered">
                                                                    <thead>
                                                                        <tr>
                                                                            <th width="40%">Nome</th>
                                                                            <th width="25%">Email</th>
                                                                            <th width="25%">Celular</th>
                                                                            <th width="10%"></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {this.state.listaBeneficiario.map((item, index) => {
                                                                            return (
                                                                                <tr key={index}>
                                                                                    <td width="40%" className='text-left'>{item.nomePresenteado}</td>
                                                                                    <td width="25%" className='text-left'>{item.emailPresenteado}</td>
                                                                                    <td width="25%" className='text-left'>{item.celularPresenteado}</td>
                                                                                    <td width="10%"><button onClick={() => this.excluirBeneficiario(index)} className='btn btn-outline-danger text-center'>Excluir</button></td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        )}

                                                        <div className="col-12 py-2 px-3">
                                                            <div className="row">
                                                                { //-- Exibição da lista de edições disponíveis para assinatura unitária.
                                                                    this.state.idPeriodo && this.state.idPeriodo.value === 5 && !this.state.isLoadingEdicoes ? (
                                                                        <div className="col-3 pb-2">
                                                                            <div className="form-group m-0">
                                                                                <label htmlFor="ddlQuantity">Edições disponíveis</label>
                                                                                <Select
                                                                                    id="ddlEdicoes"
                                                                                    placeholder=""
                                                                                    // defaultValue={this.state.edicoesDisponiveis[0]}
                                                                                    closeMenuOnSelect={true}
                                                                                    components={makeAnimated()}
                                                                                    options={this.state.edicoesDisponiveis}
                                                                                    onChange={e => this.handleSelectChange(e, "idEdicao")}
                                                                                    name="idEdicao"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="col-12 py-2">
                                                                            <div className="form-check">
                                                                                <input className="form-check-input" type="radio" name="opcaoVigencia" id="estender" checked={this.state.opcaoVigencia === "estender"} value="estender" onChange={this.handleRadio} />
                                                                                <label className="form-check-label" htmlFor="estender">Renovar assinatura</label>
                                                                                <p><small>O período selecionado será adicionado ao final da vigência da assinatura atual.</small></p>
                                                                            </div>
                                                                            <div className="form-check">
                                                                                <input className="form-check-input" type="radio" name="opcaoVigencia" id="proxEdicao" checked={this.state.opcaoVigencia === "proxEdicao"} value="proxEdicao" onChange={this.handleRadio} disabled={this.desabilitaOpcaoVigencia()} />
                                                                                <label className="form-check-label" htmlFor="proxEdicao">Receber a partir da próxima edição</label>
                                                                                <p><small>Será gerada uma nova assinatura com vigência a partir da próxima edição.</small></p>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                {this.state.idPedidoRenovacao ? (
                                                                    <div className={`col-12 text-right mb-1 ${this.state.saldoOriginal > 0 ? "offset-3" : ""}`}>
                                                                        <button disabled={this.habilitaAdicionarProduto()} onClick={this.adicionarProduto} className="btn btn-outline-success">adicionar produto</button>
                                                                    </div>
                                                                ) : (
                                                                    <div className="col-12 py-2">
                                                                        <div className="row no-gutters">
                                                                            <div className='col-12'>
                                                                                <p className='m-0'><small><strong>Desconto/acréscimo deve ser sobre a unidade do produto</strong></small></p>
                                                                            </div>
                                                                            {this.state.saldoOriginal <= 0 && (
                                                                                <div className="col-3 mr-3">
                                                                                    <label htmlFor="desconto">
                                                                                        Desconto
                                                                                        <div className="custom-control custom-radio custom-control-inline ml-3">
                                                                                            <input type="radio" id="percent" name="opcaoDesconto" className="custom-control-input" checked={this.state.opcaoDesconto === "percentual"} value="percentual" onChange={this.handleRadio} />
                                                                                            <label className="custom-control-label" htmlFor="percent">%</label>
                                                                                        </div>
                                                                                        <div className="custom-control custom-radio custom-control-inline">
                                                                                            <input type="radio" id="abs" name="opcaoDesconto" className="custom-control-input" checked={this.state.opcaoDesconto === "absoluto"} value="absoluto" onChange={this.handleRadio} />
                                                                                            <label className="custom-control-label" htmlFor="abs">R$</label>
                                                                                        </div>
                                                                                    </label>
                                                                                    {this.state.opcaoDesconto === "percentual" ? (
                                                                                        <input id="desconto" name="valorDesconto" className={`form-control text-center ${this.state.flagUtilizarSaldo ? "destaque-desconto" : " "}`}
                                                                                            type="number" value={this.state.valorDesconto} onChange={e => this.handleInputChange(e, e.target.value)} />
                                                                                    ) : (
                                                                                        <IntlCurrencyInput currency="BRL" config={currencyConfig}
                                                                                            autoComplete="off" name="valorDesconto"
                                                                                            className={`form-control text-center ${this.state.flagUtilizarSaldo ? "destaque-desconto" : " "}`}
                                                                                            value={this.state.valorDesconto} onChange={this.handleInputChange}
                                                                                        />
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                            <div className="col-3 mr-3">
                                                                                <label htmlFor="acrescimo">
                                                                                    Acréscimo
                                                                                </label>
                                                                                <input id="acrescimo" name="valorAcrescimo" className="form-control text-center" type="number" value={this.state.valorAcrescimo.toString().substring(0, 6)} onChange={this.handleInputChange} />
                                                                            </div>

                                                                            <div className={`col-3 text-right mb-1 ${this.state.saldoOriginal > 0 ? "offset-3" : ""}`}>
                                                                                <button disabled={this.habilitaAdicionarProduto()} onClick={this.adicionarProduto} className="btn btn-outline-success">adicionar produto</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {this.state.exibePedido && (
                                        <div className="col-12">
                                            <div className="row no-gutters">
                                                <div className="col-12 py-4">
                                                    <h6 className="text-center">Itens do Pedido</h6>
                                                    <div className="card">
                                                        <div className="card-body px-1">
                                                            <div className="row no-gutters px-3">
                                                                <div className="col-12" id="tabela-pedido">
                                                                    <TableOrder
                                                                        loading={this.state.isLoadingPedido}
                                                                        pedido={this.state.pedido}
                                                                        excluirItem={this.excluirItem}
                                                                        toggle={this.toggleModalBeneficiarios}
                                                                        aumentaQtde={this.aumentaQtde}
                                                                        diminueQtde={this.diminueQtde}
                                                                        idProduto={this.state.idProduto}
                                                                        verificaDigital={this.verificaDigital}
                                                                        verificaProdutoDigitalSelecionado={this.verificaProdutoDigitalSelecionado}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {this.state.pedido.length > 0 && (
                                                    <div className="col-12">
                                                        <div className="row">
                                                            <div className="col-12 py-4">
                                                                <h6 className="text-center">Dados de Entrega</h6>
                                                                <OpcaoEntrega
                                                                    opcaoEntrega={this.state.opcaoEntrega}
                                                                    handleRadio={this.handleRadio}
                                                                    calcularFrete={this.calcularFrete}
                                                                    valorFrete={this.state.valorFrete}
                                                                    toggleFrete={this.toggleFrete}
                                                                    freteAtivo={this.state.freteAtivo}
                                                                    verificaDigital={this.verificaDigital}
                                                                    buscaCEP={this.buscaCEP}
                                                                    enderecos={this.state.listaEnderecos}
                                                                    isLoadingFrete={this.state.isLoadingFrete}
                                                                    isLoadingEndereco={this.state.isLoadingEndereco}
                                                                    salvarEndereco={this.salvarEndereco}
                                                                    cepNaoEntrega={this.state.valorFrete === 0 && this.state.freteAtivo}
                                                                    mensagem={this.state.mensagem}
                                                                    toggleModalEscolherFrete={this.toggleModalEscolherFrete}
                                                                    isOpen={this.state.modalEscolherFrete}
                                                                    limparMensagem={() => this.setState({ mensagem: '' })}
                                                                    cepSelecionado={this.state.cepSelecionado}
                                                                    codMembro={this.state.infosAssinante && this.state.infosAssinante.codMembro}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>]
                    )}

                    {!!this.state.pedido && this.state.pedido.length > 0 && (
                    <>
                        <ModalBeneficiarios
                            isOpen={this.state.modalBeneficiarios}
                            toggle={this.toggleModalBeneficiarios}
                            listaBeneficiario={this.state.indexBeneficiario >= 0 ? this.state.pedido[this.state.indexBeneficiario].listaBeneficiario : []}
                            flagBeneficiarioAceite={false}
                        />
                        </>
                    )}

                    <Modal isOpen={this.state.modalErroItem} toggle={this.toggleErroItem}>
                        <ModalHeader toggle={this.toggleErroItem}>Novo item</ModalHeader>
                        <ModalBody>
                            {this.state.msgErroItem}
                        </ModalBody>
                        <ModalFooter>
                            <Button onClick={this.toggleErroItem} color="secondary">voltar</Button>
                        </ModalFooter>
                    </Modal>

                    <Modal isOpen={this.state.modalErroRenovacao} toggle={this.toggleErroRenovacao}>
                        <ModalHeader toggle={() => this.props.history.push(`/pedidos/detalhes/${this.state.idPedidoRenovacao}`)}>Renovação de assinatura</ModalHeader>
                        <ModalBody>
                            <p>Produto não encontrado.</p>
                        </ModalBody>
                        <ModalFooter>
                            {/* <Button onClick={() => this.props.history.push(`/pedidos/detalhes/${this.state.idPedidoRenovacao}`)} color="secondary">voltar</Button> */}
                            <button className="btn btn-outline-secondary" onClick={() => this.props.history.push(`/pedidos/detalhes/${this.state.idPedidoRenovacao}`)}>voltar</button>
                        </ModalFooter>
                    </Modal>

                    <Modal isOpen={this.state.modalMudarPlano} toggle={this.toggleMudarPlano}>
                        <ModalHeader toggle={this.toggleMudarPlano}>Aviso</ModalHeader>
                        <ModalBody>
                            Ao selecionar outro produto, os beneficiários serão excluídos. Deseja confirmar?
                        </ModalBody>
                        <ModalFooter>
                            <Button onClick={this.botaoConfirmar} color="success">confirmar</Button>
                            <Button onClick={this.toggleMudarPlano} color="secondary">voltar</Button>
                        </ModalFooter>
                    </Modal>
                    <Modal size="md" isOpen={this.state.modalEscolherFrete} toggle={this.toggleModalEscolherFrete}>
                        <ModalHeader toggle={this.toggleModalEscolherFrete}>Escolha do tipo de frete</ModalHeader>
                        <ModalBody>
                            <div className='row escolher-frete text-left'>
                                <div className='col-12'>
                                    {/* <p className='text-right pr-5'>Prazo de entrega</p> */}
                                    <p>Escolha o tipo de frete</p>
                                    {!!this.state.tipoFrete && this.state.tipoFrete.map((item, index) => {
                                        return (
                                            <div className='row' key={index}>
                                                <div className='col-12 py-2 text-left'>
                                                    <div className='form-check'>
                                                        <input className="form-check-input" name="tipoFrete" type="radio" id={`frete${index}`} checked={item.idTipoEntrega === this.state.idTipoFreteSelecionado} value={item.idTipoEntrega} onChange={this.handleRadioFrete} />
                                                        <label className="form-check-label" htmlFor={`frete${index}`}>
                                                            <span>{item.nome}: <strong>R$ {item.valor.toFixed(2).replace('.', ',')}</strong></span>
                                                        </label>
                                                    </div>
                                                </div>
                                                {/* <div className='col-6 py-2'>
                                                <span>{Number.parseInt(Math.random() * 10, 10)} dia(s)</span>
                                            </div> */}
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className='row pt-3'>
                                <div className='col-6 text-right'>
                                    <button className='btn btn-outline-success' disabled={!this.state.idTipoFreteSelecionado} onClick={this.incluirFrete}>incluir frete</button>
                                </div>
                                <div className='col-6 text-left'>
                                    <button className='btn btn-outline-secondary' onClick={this.calcularPrazo}>calcular prazo</button>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>
                    <ErrorModal
                        isOpen={this.state.hasError}
                        message={this.state.errorMessage}
                        closeErrorModal={this.closeErrorModal}
                    />
                </div>
            </div >
        )
    }
}
export default NewOrder;